import {
	DEFAULT_SETTINGS_REQUEST,
	DEFAULT_SETTINGS_FAIL,
	DEFAULT_SETTINGS_SUCCESS,
} from "../actions/types";

const initialState = {
	isLoading: false,
	error: false,
	data: null,
};

const projectSettingsReducer = (state = initialState, action) => {
	switch (action.type) {
		case DEFAULT_SETTINGS_REQUEST:
			return {...state, isLoading: true};
		case DEFAULT_SETTINGS_SUCCESS:
			return {
				...state,
				isLoading: false,
				data: action.payload.data,
			};
		case DEFAULT_SETTINGS_FAIL:
			return {
				...state,
				isLoading: false,
				error: action.payload.error,
			};
		// case USER_LOGOUT:
		// 	return {};
		default:
			return state;
	}
};

export default projectSettingsReducer;
